module.exports = __webpack_public_path__ + "1ac2197564365fb11be8ef84d1dc83a1.png";